import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { api as buildsApi } from '@saucelabs/sl-module-builds';
import { actions as jobsActions, api as jobsApi } from '@saucelabs/sl-module-jobs';
import { jobHelpers } from '@saucelabs/sl-util-helpers';

import * as actions from './actions';

export const openBadgeConfiguratorModal = () => (dispatch) => {
  dispatch(modalActions.showModal('badgeConfigurator'));
};

export const toggleCard = ({ username, build, isOpen }) => async (dispatch) => {
  if (!isOpen) {
    await dispatch(jobsActions.getFailedJobs({ username, build }, { skipErrorPage: true }));
  }
  dispatch(actions.toggleBuildCard(build));
};

export const stopBuild = ({ id }) => async (dispatch) => {
  const { data: { jobs: buildJobs } } = await buildsApi.getBuildJobs({ id, full: true });
  const runningJobs = buildJobs.filter((job) => jobHelpers.getStatus(job.status) === 'running');

  await Promise.all(runningJobs.map((job) => jobsApi.stopJob({ id: job.id, username: job.owner })));

  return dispatch(notificationActions.notifyInfo('Stopping running tests from this build'));
};
